import { render, staticRenderFns } from "./EditSub.vue?vue&type=template&id=bafd638a&"
import script from "./EditSub.vue?vue&type=script&lang=js&"
export * from "./EditSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!C:/Projects/rentmagic.website.vue.limburg/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormInput, BCol, BRow, BCard, BButton, BForm, BContainer} from 'bootstrap-vue'
    installComponents(component, {BFormInput, BCol, BRow, BCard, BButton, BForm, BContainer})
    

export default component.exports